<template>
  <a
    href="/collections/all"
    class="media-card"
    :style="{
      '--backgroundImageSmall': `url(${backgroundImages?.smallMedia})`,
      '--backgroundImageMedium': `url(${backgroundImages?.mediumMedia})`,
      '--backgroundImageLarge': `url(${backgroundImages?.largeMedia})`,
    }"
  >
    <div class="media-card__image">
      <div v-if="videoUrl && !lowPower" class="video-intersection-observer">
        <Video
          :video="{
            sources: [
              {
                url: videoUrl,
              },
            ],
          }"
          @lowPower="lowPower = true"
        >
        </Video>
      </div>
      <h1 v-if="!mq.mdPlus" class="title-mobile">{{ title }}</h1>
      <h1 v-if="mq.mdPlus">{{ desktopTitle }}</h1>
      <div class="content-container">
        <div v-if="mq.xsPlus" class="cta-group">
          <slot name="cta"></slot>
        </div>
        <div v-if="logo" class="logo-container">
          <img src="@/assets/images/logo.svg" class="logo" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import Video from "@/components/Video.vue";

export default {
  name: "AW23Hero",
  components: {
    Video,
  },
  inject: ["mq"],
  props: {
    videoUrl: {
      type: String,
      default: null,
    },
    images: {
      type: Object,
      required: true,
    },
    lowPowerImages: {
      type: Object,
      default: () => {},
    },
    logo: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    desktopTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      lowPower: false,
    };
  },
  computed: {
    backgroundImages() {
      if (this.lowPower) {
        return this.lowPowerImages;
      }

      return this.images;
    },
  },
};
</script>

<style lang="scss" scoped>
.media-card {
  text-decoration: none;

  @include respond-above(md) {
    text-align: center;
  }

  &__image {
    color: $color-white;
    aspect-ratio: 0.75;
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding: 45px;
    position: relative;

    background-image: var(--backgroundImageSmall);
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;

    @include respond-above(sm) {
      background-image: var(--backgroundImageMedium);
    }

    @include respond-above(md) {
      aspect-ratio: auto;
      height: 90vh;
      justify-content: center;
      background-image: var(--backgroundImageLarge);
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 50%,
        rgba(0, 0, 0, 0.5) 90%
      );
    }
  }

  h1 {
    align-self: center;
    font-family: $heading-font-family;
    font-size: 40px;
    text-transform: uppercase;
    font-weight: 500;
    color: $color-white;
    z-index: 1;
    text-decoration: none;
    position: absolute;
    top: 50%;

    @include respond-above(md) {
      @include t__editorial-headline-50;
      position: static;
      text-align: center;
      top: 0;
      transform: none;
    }

    @include respond-above(xl) {
      @include t__editorial-headline-80;
    }

    .title-wrap {
      display: block;
      margin-left: 50px;

      @include respond-above(md) {
        display: inline;
        margin-left: 0;
      }
    }
  }

  .content-container {
    top: 58%;
    left: 0;
    position: absolute;
    width: 100%;
    @include respond-above(md) {
      top: 55%;
    }
    @include respond-above(xl) {
      top: 58%;
    }
  }
  .cta-group {
    margin: 0 0 20px 0;
    z-index: 1;
    position: relative;
    width: 100%;
    text-align: center;

    @include respond-above(md) {
      align-self: auto;
      margin: 0;
    }
  }

  .logo-container {
    display: flex;
    justify-content: center;
  }

  .logo {
    display: none;
    @include respond-above(md) {
      width: 90%;
      z-index: 1;
      filter: invert(1);
      display: block;
    }
  }

  ::v-deep(.button) {
    color: $color-white;
    font-size: 14px;
    font-weight: 500;
    font-family: $heading-font-family;
    padding: 0;
    display: inline-block;

    @include respond-above(md) {
      font-size: 24px;
    }
  }

  .video-intersection-observer {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;

    ::v-deep(.video__element) {
      object-fit: cover;
    }
  }
}
</style>
